import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TopbarComponent } from '../topbar/topbar.component';
import { LayoutService } from '../shared/layout.service';
import { ApiService } from '../shared/api.service';
import { StoreService } from '../shared/store.service';
import { TokenStorageService } from '../shared/token-storage.service';
import { ThemeService } from '../shared/theme.service';

@Component({
  standalone: true,
  selector: 'app-shell',
  imports: [CommonModule, RouterLink, RouterOutlet, TopbarComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss'
})
export class ShellComponent implements OnInit {
  layout = inject(LayoutService);
  storeService = inject(StoreService);
  themeService = inject(ThemeService);
  private api = inject(ApiService);
  private tokenStorage = inject(TokenStorageService);

  ngOnInit() {
    console.log('ShellComponent initialized');
    this.checkStore();
  }

  private checkStore() {
    console.log('checkStore called');
    const user = this.tokenStorage.getUser();
    console.log('User from token:', user);
    const userEmail = user?.email;
    console.log('User email:', userEmail);
    
    if (userEmail) {
      console.log('Making API call to getStoreByEmail with:', userEmail);
      this.api.getStoreByEmail(userEmail).subscribe({
        next: (response) => {
          console.log('Store API response:', response);
          const storeId = response?.store_id;
          console.log('Setting store_id to:', storeId);
          this.storeService.setStoreId(storeId);
        },
        error: (err) => {
          console.error('Erro ao verificar store:', err);
          this.storeService.setStoreId(null);
        }
      });
    } else {
      console.warn('No email found in token');
    }
  }
}
